export default __webpack_public_path__ + "static/media/network-icon.b1896279.svg";